import React from 'react'
import HeaderNew from '../header/HeaderNew';
import Breadcrumb from '../inner/Breadcrumb';
import AboutOne from '../elements/AboutOne';
import WorkingProcess from '../elements/WorkingProcess';
import Team from '../elements/Team';
import TestimonialsBrand from '../elements/TestimonialsBrand';
import Footer from '../elements/Footer';

function about() {
    return (
        <div className="index-one">
            <HeaderNew />
            <main>
                {/*
                <div className="breadcrumb-area bg_image tmp-section-gap "
                    style={{ backgroundImage: `url(assets/images/breadcrumb/about.webp)` }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-inner text-center">
                                    <h1 className="title split-collab">About Us</h1>
                                    <ul className="page-list">
                                        <li className="tmp-breadcrumb-item">
                                            <a href="/">Home</a>
                                        </li>
                                        <li className="icon">
                                            <i className="fa-solid fa-angle-right" />
                                        </li>
                                        <li className="tmp-breadcrumb-item active">About</li>
                                    </ul>
                                    <div className="circle-1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                */}
                <AboutOne />
                <WorkingProcess />
                <Team />
                <Footer />
            </main>
            <style>
                {`
                .tpm-services-process-area{
                    background: linear-gradient(to right, rgba(237, 245, 255, 0.1) 0%, #ccdff7 100%);
                }
                `}
            </style>
        </div>
    )
}

export default about